import { render, staticRenderFns } from "./EditBundling.vue?vue&type=template&id=5cce0b80&"
import script from "./EditBundling.vue?vue&type=script&lang=js&"
export * from "./EditBundling.vue?vue&type=script&lang=js&"
import style0 from "./EditBundling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports